import axios from '../../axios-atis'

import * as actionTypes from './actionTypes';

export const fetchSectionsBegin = () => ({
    type : actionTypes.FETCH_SECTIONS_BEGIN
});

export const fetchSectionsSuccess =  sections  => {
    return {
        type: actionTypes.FETCH_SECTIONS_SUCCESS,
        payload: { sections }
    }
};

export const fetchSectionsError = error => {
    return {
        type: actionTypes.FETCH_SECTIONS_FAILED,
        payload: { error }
    };
};
export const fetchSections = (page, pageSize, filtred, sorted) => {
    //console.log("fetchSections");
    return dispatch => {
        dispatch(fetchSectionsBegin());
        let url = '/sections';
        axios.get(url)
            .then(response => {
                dispatch(fetchSectionsSuccess(response.data));
            })
            .catch(err => {
                dispatch(fetchSectionsError(err));
            });
    };
};

export const fetchSectionBegin = () => ({
    type : actionTypes.FETCH_SECTION_BEGIN
});

export const fetchSectionSuccess =  section  => {
    return {
        type: actionTypes.FETCH_SECTION_SUCCESS,
        payload: { section }
    }
};

export const fetchSectionError = error => {
    return {
        type: actionTypes.FETCH_SECTION_FAILED,
        payload: { error }
    };
};
export const fetchSection = (id) => {
    return dispatch => {
        dispatch(fetchSectionBegin());
        let url = '/sections/'+id;
        axios.get(url)
            .then(response => {
                dispatch(fetchSectionSuccess(response.data));
            })
            .catch(err => {
                dispatch(fetchSectionError(err));
            });
    };
};

export const addSectionBegin =  ()  => {
    return {
        type: actionTypes.ADD_SECTION_BEGIN
    }
};

export const addSectionSuccess =  (section)  => {
    return {
        type: actionTypes.ADD_SECTION_SUCCESS,
        payload: { section }
    }
};

export const addSectionError = error => {
    return {
        type: actionTypes.ADD_SECTION_FAILED,
        payload: { error }
    };
};
export const addSection = (newSection) => {
    return dispatch => {
        dispatch(addSectionBegin());
        let url = '/sections';
        axios.post(url, newSection)
        .then(response => {
            if (response.data.result===null) {
                dispatch(addSectionError(response.data));
            } else {
                dispatch(addSectionSuccess(response.data.result));
            }
        })
        .catch(err => {
            dispatch(addSectionError(err));
        });
    };
};

export const updtSectionBegin =  ()  => {
    return {
        type: actionTypes.UPDATE_SECTION_BEGIN
    }
};

export const updtSectionSuccess =  (section)  => {
    return {
        type: actionTypes.UPDATE_SECTION_SUCCESS,
        payload: { section }
    }
};

export const updtSectionError = error => {
    return {
        type: actionTypes.UPDATE_SECTION_FAILED,
        payload: { error }
    };
};
export const updtSection = (section) => {
    return dispatch => {
        dispatch(updtSectionBegin());
        let url = `/sections/${section.id}`;
        axios.post(url, section)
        .then(response => {
            if (undefined === response || undefined === response.data) {
                dispatch(updtSectionError(null));    
            }
            dispatch(updtSectionSuccess(response.data.result));  
        })
        .catch(err => {
            dispatch(updtSectionError(err));
        });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/section.js